import React, { createRef, useState, useEffect } from 'react';
import { CustomInput, SectionLabel } from '../../../components/common';
import AccordionTile from '../Accordion';
import {
  Package,
  PackageProduct,
  ProductTemplateKey,
  useCreatePackageProduct,
  useUpdatePackageProduct,
} from '../../../hooks/useClients';
import { ProductTemplate } from '../../../hooks/useClients';

interface RewardsPTOProps {
  packageData: Package;
  defaultTemplate: ProductTemplate;
  setSaveDataModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const RewardsPTO: React.FunctionComponent<RewardsPTOProps> = ({
  packageData,
  defaultTemplate,
  setSaveDataModal,
}): JSX.Element => {
  const selectedPackageProduct = packageData.package_products.find(
    (item: PackageProduct) => item.product.key === ProductTemplateKey.REWARD_PTO,
  );
  const { createPackageProduct } = useCreatePackageProduct(
    packageData.client_id!,
    selectedPackageProduct?.package_id! || packageData.id!,
    defaultTemplate.id,
  );
  const { updatePackageProduct } = useUpdatePackageProduct(packageData.client_id!, selectedPackageProduct?.id!);

  const [image, setimgPreview] = useState<string | null>();
  const fileInput: any = createRef();
  const [rewardPto, setrewardPto] = useState<boolean>(true);
  const [rewardMilestone, setrewardMilestone] = useState<number>(0);
  const [rewardMilestomeValue, setrewardMilestomeValue] = useState<number>(0);

  const [preloadedImage, setpreloadedImage] = useState<boolean>(false);
  const [enableSaveOption, setenableSaveOption] = useState<boolean>(false);
  const [ErrorMessage, setErrorMessage] = useState<{
    rewardMilestone?: string;
    rewardMilestomeValue?: string;
  }>({});

  const onFileChange = async (event: any) => {
    try {
      //

      if (event.target.files && event.target.files[0]) {
        // setimage(event.target.files[0]);
        let reader = new FileReader();
        reader.onload = (e: any) => {
          setimgPreview(e.target.result);
          setpreloadedImage(false);
          setenableSaveOption(true);
        };
        reader.readAsDataURL(event.target.files[0]);
      }

      // Update the state
    } catch (error) {
      console.error('err--', error);
    }
  };

  const hadleImageinpuy = (e: any) => {
    fileInput.current.click();
  };

  useEffect(() => {
    setSaveDataModal(enableSaveOption);
  }, [enableSaveOption]);

  useEffect(() => {
    if (packageData) {
      if (selectedPackageProduct) {
        setrewardPto(selectedPackageProduct?.status === 'enabled' ? true : false);

        const configuration = selectedPackageProduct.configuration;
        setrewardMilestone(configuration.required_points);
        setrewardMilestomeValue(configuration.pto_reward_value);
        if (configuration.image_url) {
          setimgPreview(configuration.image_url);
          setpreloadedImage(true);
        }
      } else {
        const configuration = defaultTemplate.configuration;
        setrewardPto(false);
        setrewardMilestone(configuration.required_points);
        setrewardMilestomeValue(configuration.pto_reward_value);
        if (configuration.image_url) {
          setimgPreview(configuration.image_url);
          setpreloadedImage(true);
        }
      }
      setenableSaveOption(false);
    }
  }, [packageData]); // eslint-disable-line react-hooks/exhaustive-deps

  const Validation = () => {
    // if (!rewardMilestone || !rewardMilestomeValue) {
    //     seterror(true);
    //     return false;
    // }
    if (rewardPto) {
      if (!rewardMilestone) {
        setErrorMessage({ rewardMilestone: 'Field is required' });
        return false;
      } else if (rewardMilestone.toString().indexOf('.') !== -1) {
        setErrorMessage({
          rewardMilestone: 'Number may not include decimals - whole numbers only',
        });
        return false;
      } else if (rewardMilestone < 1 || rewardMilestone > 50) {
        setErrorMessage({ rewardMilestone: 'Must be a number between 1 and 50' });
        return false;
      } else if (!rewardMilestomeValue) {
        setErrorMessage({ rewardMilestomeValue: 'Field is required' });
        return false;
      } else if (rewardMilestomeValue.toString().indexOf('.') !== -1) {
        setErrorMessage({
          rewardMilestomeValue: 'Number may not include decimals - whole numbers only',
        });
        return false;
      } else if (rewardMilestomeValue < 1 || rewardMilestomeValue > 50) {
        setErrorMessage({ rewardMilestomeValue: 'Must be a number between 1 and 50' });
        return false;
      }
    }
    setErrorMessage({});
    return true;
  };

  const onSave = () => {
    const payload: Partial<PackageProduct> = {
      status: rewardPto ? 'enabled' : 'disabled',
      configuration: {
        pto_reward_value: +rewardMilestomeValue,
        required_points: +rewardMilestone,
        ...(preloadedImage ? {} : { image_url: image }),
      },
    };
    if (Validation()) {
      if (selectedPackageProduct) {
        updatePackageProduct.mutate(payload);
      } else {
        createPackageProduct.mutate(payload);
      }
    }
  };

  return (
    <AccordionTile
      setStatus={(data: boolean) => {
        if ((!data && Validation()) || data) {
          !enableSaveOption && setenableSaveOption(true);
          setrewardPto(data);
        }
      }}
      Label={'REWARD PTO '}
      status={rewardPto}
      buttonText={'SAVE'}
      id={'rewardPto'}
      disableButton={enableSaveOption}
      onButtonClick={() => {
        if (enableSaveOption) onSave();
      }}
      initialstatus={true}
      InnerComponent={
        <div className="my-10 flex justify-evenly gap-7">
          <div className="w-full">
            <div className="py-4">
              <CustomInput
                inputType={'number'}
                value={rewardMilestone}
                setValue={(data) => {
                  !enableSaveOption && setenableSaveOption(true);
                  setrewardMilestone(data);
                }}
                Label={'Reward Milestone'}
                Error={ErrorMessage?.rewardMilestone?.length > 0 ? true : false}
                ErrorMessage={ErrorMessage?.rewardMilestone}
                dataTestId="reward-milestone"
              />
            </div>
            <div className="py-4">
              <CustomInput
                inputType={'number'}
                value={rewardMilestomeValue}
                setValue={(data) => {
                  !enableSaveOption && setenableSaveOption(true);
                  setrewardMilestomeValue(data);
                }}
                Label={'Milestone Reward  value'}
                Error={ErrorMessage?.rewardMilestomeValue?.length ? true : false}
                ErrorMessage={ErrorMessage?.rewardMilestomeValue}
                dataTestId="reward-milestone-value"
              />
            </div>
          </div>
          <div className="w-full">
            <div className="py-4">
              <SectionLabel Label="Reward Graphic" />
            </div>
            <div className="flex w-full">
              <div
                className="aspect-ratio-container flex w-full cursor-pointer items-center justify-center rounded-sm bg-gray-200"
                onClick={hadleImageinpuy}
                data-testid="add-reward-graphic-pto"
              >
                {image ? (
                  <img className="h-full w-full" src={image} alt="clientImage" />
                ) : (
                  <div className="flex h-56 items-center justify-center">
                    <button className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-3xl">
                      +
                    </button>
                    <input
                      ref={fileInput}
                      id="file-upload"
                      type="file"
                      className="hidden"
                      accept="image/*"
                      onClick={() => {
                        fileInput.current.value = null;
                      }}
                      onChange={(data) => {
                        !enableSaveOption && setenableSaveOption(true);
                        onFileChange(data);
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="pl-6">
                {image && (
                  <button
                    className="my-2 w-full rounded-full bg-gray-300 p-2 text-center text-sm text-white"
                    onClick={() => {
                      setimgPreview(null);
                      setpreloadedImage(false);
                      !enableSaveOption && setenableSaveOption(true);
                    }}
                    data-testid="pto-remove-reward-graphic"
                  >
                    REMOVE
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default RewardsPTO;
